import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { AmbikaVenderApi } from "../config";

const RouteCard = ({
  route,
  productStatusCode,
  onInfoClick,
  staticStatusCodes,
}) => {
  const formatQuantity = (product) => {
    const ordered = product.product_qty || 0;
    const ready = product.food_ready_qty || 0;
    const dispatched = product.dispatch_qty || 0;
    const parts = [];

    if (ordered !== 0) parts.push(ordered);
    if (ready !== 0) parts.push(ready);
    if (dispatched !== 0) parts.push(dispatched);

    return parts.join(" / ");
  };

  const getStatusIcons = (product) => {
    const icons = [];

    // 1. First find and push status color if status is a number
    if (product.status && typeof product.status === "number") {
      const productStatus = productStatusCode?.find(
        (status) => status.id === product.status
      );
      if (productStatus) {
        icons.push(
          <div
            key={`status-${product.status}`}
            className="status-icon"
            style={{
              backgroundColor: productStatus.color_code,
              width: "22px",
              height: "22px",
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "5px",
              cursor: "pointer",
            }}
            title={productStatus.name}
          />
        );
      }
    }

    // Helper to render static status codes (U, P, O, Z)
    const renderStaticIcon = (code, tooltip) => {
      return (
        <div
          key={`static-${code}-${Math.random()}`}
          className="status-icon"
          style={{
            backgroundColor: "white",
            color: "black",
            border: "1.5px solid #212529",
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "11px",
            marginRight: "5px",
            cursor: "pointer",
          }}
          title={tooltip}
        >
          {code}
        </div>
      );
    };

    // 2. Add U icon if urgent
    if (product.is_urgent === 1) {
      const urgentStatus = staticStatusCodes.find(
        (status) => status.code === "U"
      );
      if (urgentStatus) {
        icons.push(renderStaticIcon("U", urgentStatus.name));
      }
    }

    // 3. Add P icon if parcel
    if (product.is_parcel === 1) {
      const parcelStatus = staticStatusCodes.find(
        (status) => status.code === "P"
      );
      if (parcelStatus) {
        icons.push(renderStaticIcon("P", parcelStatus.name));
      }
    }

    // 4. Add string status (O or Z)
    if (product.status && typeof product.status === "string") {
      const staticStatus = staticStatusCodes.find(
        (status) => status.code === product.status
      );
      if (staticStatus) {
        icons.push(renderStaticIcon(staticStatus.code, staticStatus.name));
      }
    }

    return icons;
  };

  return (
    <div className="col-12">
      <div className="card no-border h-100">
        <div className="card-body d-flex flex-column">
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <h6 className="fw-bold mb-0 p-3">
              {route.route_name || `Route ${route.route_id}`}
            </h6>
            {/* <span
              className="info-icon p-3"
              style={{ cursor: "pointer" }}
              onClick={onInfoClick}
            >
              <BsFillInfoCircleFill />
            </span> */}
          </div>

          <ul className="list-unstyled small flex-grow-1">
            {route.product_detail?.map((product, index) => {
              const rawOrder = product.orderNo || product.order_no || product.orderId || product.order_id || product.id;
              let orderNoArray = [];
              if (rawOrder) {
                if (Array.isArray(rawOrder)) {
                  orderNoArray = rawOrder.map(o => String(o).replace(/\\/g, ""));
                } else {
                  orderNoArray = String(rawOrder).split(",").map(o => o.trim().replace(/\\/g, ""));
                }
              }
              const orderNoDisplay = orderNoArray.filter(Boolean).join(", ");

              return (
                <li
                  key={`${product.product_id}-${product.size_name}-${index}`}
                  className="d-flex justify-content-between small-list-item px-3 align-items-center"
                >
                  <div className="icon-text-wrapper d-flex align-items-center" style={{ minWidth: 0, flex: 1, marginRight: "10px" }}>
                    <div className="d-flex align-items-center flex-shrink-0">
                      {getStatusIcons(product)}
                    </div>
                    <div className="d-flex flex-column ms-2" style={{ alignItems: "flex-start", textAlign: "left", minWidth: 0 }}>
                      <span style={{ fontWeight: "500", fontSize: "13px", color: "#212529", lineHeight: "1.4" }}>
                        {product.productName} ({product.size_name})
                      </span>
                      {orderNoDisplay && (
                        <span className="text-muted" style={{ fontSize: "10px", marginTop: "2px", fontWeight: "normal", wordBreak: "break-all" }}>
                          {orderNoArray.length > 1 ? "Orders: " : "Order: "}{orderNoDisplay}
                        </span>
                      )}
                    </div>
                  </div>
                  <span className="flex-shrink-0 fw-semibold text-end" style={{ fontSize: "13px", minWidth: "45px" }}>
                    {formatQuantity(product)}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RouteCard;
